<template>
  <v-app>
    <v-main :style="appStyle" id="app">
      <div id="login">
        <div v-if="!status" ><p style="color:#ffedc7; text-align:center" @click="handleLogin">狼友，请先<a style="color:#fc4e3c">登录</a></p></div>
        <div v-if="status === 'select_role'"><p style="color:#ffedc7" @click="selectRoleDialog=true">狼友，请先<a style="color:#fc4e3c">选择角色</a></p></div>
        <div v-if="status === 'login'" style="text-align:center">
          <!-- <v-btn depressed small class="btnColor" @click="award=true">
            <img src="./assets/gift.png" alt="" class="icon-gift">
            我的包裹
          </v-btn> -->
          <div style="margin-left: 3vw; margin-top: 1vw; font-size: 16px;color: #fc4e3c">{{roleName}} <span style="color:#ababab" @click="logout">注销</span> </div>
        </div>
      </div>
      <!-- <QuestionBoard @runout="runout" @answerRight="getCount" :login="status === 'login'" @logout="logout"/>
      <LuckyBoard @runout="runout" :count='count' @logout="logout" @draw="--count"/> -->
      <Login :loginDialog="loginDialog" @close="loginDialog=false" @loginSucc="loginSucc" @selectRole="selectRole($event)"/>
      <SelectRole :visible="selectRoleDialog" :roleList="roleList" @close="selectRoleDialog=false" @succ="selectRoleSucc"/>
      <SantaTree 
        :makingWish="makingWish"
        :myWish="myWish"
        @consumeWish="makingWish.shift()"
        @check-random="checkWish('wishRandom')"
        @check-own="checkWish('wishOwn')"
        @check-detail="checkDetail"
        @check-wish="wishList"
        @go-wish="count > 0 ? checkWish('wishBoard') : myWish.length < 2 ? checkWish('wishShareTip') : checkWish('wishOwn')"
        @go-share="checkWish('wishShareCard')"
      />
      <ModalTransformer 
      :activated="activated"
      :userInfo="roleName"
      :dialog="santaDialog" 
      :wishData="wishData"
      :socksIndex="socksIndex"
      :wishCount="count"
      :myWish="myWish"
      @login="handleLogin"
      @shareSucc="getCount"
      @wishComplete="makeWish"
      @close="santaDialog=false"/>
      <!-- <Awards :award="award" @close-modal="award=false" @logout="logout"/>
      <Tip :tipStatus="tip" :tipText="tipText" @close-modal="tip=false"/>
      <Footer/> -->
      <RuleButton />
    </v-main>
  </v-app>
</template>

<script>
import Login from './components/Login'
import SelectRole from './components/SelectRole'
// import QuestionBoard from './components/QuestionBoard'
// import LuckyBoard from './components/LuckyBoard'
// import Tip from './components/Tip'
// import Awards from './components/Awards'
// import Footer from './components/Footer'
import SantaTree from './components/SantaTree'
import ModalTransformer from './components/ModalTransformer'
import RuleButton from './components/RuleButton'
import * as api from '@/api/index'
import mixin from '@/mixins'
export default {
  name: 'App',
  components: {
    Login,
    // QuestionBoard,
    // LuckyBoard,
    // Tip,
    // Awards,
    // Footer,
    SelectRole,
    SantaTree,
    ModalTransformer,
    RuleButton
  },
  mixins: [mixin],
  data: () => ({
    appStyle: {
      backgroundImage: "url(" + require("@/assets/bg.jpg") + ")",
    },
    status: localStorage.getItem('status') === 'login' ? 'login' : undefined,
    loginDialog: false,
    selectRoleDialog: false,
    tip: false,
    tipText: '',
    award: false,
    count: 1,
    roleName: localStorage.getItem('role_name') || '',
    roleList: [],
    santaDialog: false,
    activated: '',
    wishData: [],
    socksIndex: '',
    makingWish: [],
    myWish: []
  }),
  methods: {
    checkWish(a) {
      console.log({a})
      this.santaDialog = true
      this.activated=a
    },
    wishList(data) {
      this.wishData = data
      if (this.roleName) {
        this.getCount()
        this.getMakingWish()
      }
    },
    checkDetail(index) {
      this.socksIndex = index
      this.checkWish('wishSocks')
    },
    makeWish(res) {
      this.count--
      this.makingWish.push(this.roleName)
      this.getMakingWish()
    },
    handleLogin() {
      this.loginDialog = true
    },
    loginSucc() {
      this.loginDialog = false
      this.status = localStorage.getItem('status')
      this.roleName = localStorage.getItem('role_name') || ''
      if (this.wishData) {
        this.getCount()
        this.getMakingWish()
      }
    },
    selectRole(roleList) {
      console.log("roleList",roleList)
      this.roleList = roleList
      this.loginDialog = false
      this.status = localStorage.getItem('status')
      this.selectRoleDialog = true
    },
    selectRoleSucc() {
      this.selectRoleDialog = false
      this.status = localStorage.getItem('status')
      this.roleName = localStorage.getItem('role_name') || ''
      if (this.wishData) {
        this.getCount()
        this.getMakingWish()
      }
    },
    runout(t) {
      this.tip = true
      this.tipText = t
    },
    async getCount() {
      const res = await api.wishChance({
        activity_id: this.wishData.activity_id
      })
      .catch(err => {
        this.errorHandler(err, this.logout)
      })
      if (res != null) {
        this.count = res
      }
    },
    async getMakingWish() {
      const res = await api.myWish({
        activity_id: this.wishData.activity_id
      })
      .catch(err => {
        this.errorHandler(err, this.logout)
      })
      if (res != null) {
        this.myWish = res
      }
    },
    logout() {
      this._logout()
      this.status = undefined
      this.count = 1
      this.roleName = ''
    }
  }
};
</script>

<style>
body {
  margin: 0;
}
#app {
  width: 100%;
  height: 213.33vw;
  background-size: 100% 100%;
}
#login {
  /* float:center; */
  margin-right: 5vw;
  margin-top: 5vw;
}
.btnColor {
   background-color: rgba(0, 0, 0, 0.6) !important;
   color: white !important;
 } 
.icon-gift {
  width: 6.667vw;
  height: 7.2vw;
}

</style>